import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  users: [],
  user_positions: [],
  user: {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    gccNumber: "",
    type: "",
    role: "",
    supplierId: ""
  },
  totalUsers: 0
};

const getters = {};

const actions = {
  LOAD_USERS: function({ commit, rootState }, payLoad) {
    let approvedQuery =
      payLoad.approved === 1 || payLoad.approved === 0
        ? "&approved=" + payLoad.approved
        : "";
    let activeQuery =
      payLoad.active === 1 || payLoad.active === 0
        ? "&active=" + payLoad.active
        : "";
    let nameQuery =
      payLoad.name !== undefined && payLoad.name !== null && payLoad.name !== ""
        ? "&name=" + payLoad.name
        : "";
    return Vue.prototype.$axios
      .get(
        "/users?from=" +
          payLoad.from +
          "&limit=" +
          payLoad.to +
          approvedQuery +
          nameQuery +
          activeQuery
      )
      .then(
        response => {
          commit("SET_USERS", response.data.users);
          commit("SET_TOTAL_USERS", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  LOAD_USER: async function({ commit, rootState }, payLoad) {
    return Vue.prototype.$axios
      .get("/users/" + payLoad.userId)
      .then(response => {
        commit("SET_USER", response.data.user);
      });
  },
  CREATE_USER: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios.post("/users", payload).then(
      response => {},
      err => {
        throw new Error(err);
      }
    );
  },
  UPDATE_USER: async function({ commit }, payload) {
    return await Vue.prototype.$axios.post("users/" + payload.id, payload).then(
      res => {
        Vue.prototype.$swal({
          title: "Success",
          html: "User has been updated",
          icon: "info"
        });
      },
      err => {
        throw new Error(err);
      }
    );
  },
  UPDATE_ACTIVE_STATUS: function({ commit, rootState, dispatch }, payLoad) {
    return Vue.prototype.$axios
      .patch(
        "/users/" + payLoad.userId + "/state",
        {
          active: payLoad.active
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(
        response => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  },
  LOAD_USER_POSITIONS: async function({ commit }, payload) {
    return await Vue.prototype.$axios.get("user/positions").then(res => {
      commit("SET_USER_POSITIONS", res.data.userPositions);
    });
  },
  DESTROY_USER: async function({ commit }, payload) {
    return await Vue.prototype.$axios.delete("users/" + payload);
  },
  LOAD_SUPPLIER_USERS: async function({ commit }, payload) {
    let approvedQuery =
      payload.approved === 1 || payload.approved === 0
        ? "&approved=" + payload.approved
        : "";
    let activeQuery =
      payload.active === 1 || payload.active === 0
        ? "&active=" + payload.active
        : "";
    let nameQuery =
      payload.name !== undefined && payload.name !== null && payload.name !== ""
        ? "&name=" + payload.name
        : "";
    return await Vue.prototype.$axios
      .get(
        "/suppliers/" +
          payload.supplierId +
          "/users?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          approvedQuery +
          nameQuery +
          activeQuery
      )
      .then(response => {
        commit("SET_USERS", response.data.users);
        commit("SET_TOTAL_USERS", response.data.meta.total);
        return response;
      });
  },
  CHANGE_PASSWORD: async function({ commit, rootState }, payload) {
    return await Vue.prototype.$axios
      .post("users/" + rootState.auth.authUser.id + "/password", payload)
      .then(
        res => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  }
};

const mutations = {
  SET_USERS: (state, users) => {
    state.users = users;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_TOTAL_USERS: (state, total) => {
    state.totalUsers = total;
  },
  SET_USER_POSITIONS: (state, positions) => {
    state.user_positions = positions;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
